import { Component, inject } from '@angular/core';
import { MatIconRegistry, MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { RemoveProposalAlertSnackbarData } from './remove-proposal-alert-snackbar-data.interface';

@Component({
  selector: 'remove-proposal-alert',
  templateUrl: './removeProposalAlert.component.html',
  styleUrls: ['./removeProposalAlert.component.scss'],
  imports: [MatIcon],
})
export class RemoveProposalAlertComponent {
  data = inject<RemoveProposalAlertSnackbarData>(MAT_SNACK_BAR_DATA);
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  constructor() {
    this.matIconRegistry.addSvgIcon(
      'trash',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/trash.svg')
    );
  }
}
